import Breadcrumb from '@/components/ui/Breadcrumb'
import LeadershipCouncil from '@/components/sections/LeadershipCouncil'
import FunctionsResponsibilities from '@/components/sections/FunctionsResponsibilities'
import AUAssemblySection from '@/components/sections/AUAssemblySection'
import { useAllWebPages } from '@/lib/api/hooks/web-pages'
import FullPageSpinner from '@/components/ui/FullPageSpinner'
import { parseHtmlString } from '@/utils/helpers/html'

const Leadership = () => {
  const { data, isFetching, isError, refetch } = useAllWebPages();

  const leadershipData = data?.data && data?.data.find((page) =>
    page.codeName?.toLowerCase() === 'leadership' ||
    page.websitePageName?.toLowerCase() === 'leadership'
  )?.content || null;

  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    { label: 'About Us', href: '/about' },
    { label: 'Leadership', href: '/about/leadership', active: true }
  ]

  if (isFetching) {
    return <FullPageSpinner />;
  }

  if (isError) {
    return <div className="p-4 flex flex-col items-center justify-center h-full w-full gap-4">
      <p>Error loading page.</p>
      <button onClick={() => refetch()} className="px-4 py-2 bg-forestGreen-100 text-white rounded">Retry</button>
    </div>;
  }

  if (!leadershipData) {
    return <div className="p-4 flex flex-col items-center justify-center h-full w-full gap-4">
      <p>Page content not found.</p>
    </div>;
  }

  return (
    <div className="bg-white min-h-screen">
      {/* Breadcrumb */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8  ">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      {/* Hero Section */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <img
          src={leadershipData?.LEADERSHIP_BANNER?.fileUrl ?? "https://res.cloudinary.com/dlwegkhme/image/upload/v1755760297/0419d7b9498659c65e546b484c3a84dbb59d1976_2_grc2la.png"}
          alt="African Space Agency Leadership Group Photo"
          className="w-full h-[300px] md:h-[480px] object-cover"
        />
      </div>

      {/* Leadership Introduction */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 pb-8 md:pt-20">
        <div className="max-w-5xl">
          <h1 className="text-3xl md:text-4xl font-normal font-pt-serif text-gray-100 leading-tight mb-6">
            {leadershipData?.LEADERSHIP_THE_AFRICA_SPACE_COUNCIL?.title ?? "Leadership - The African Space Council"}
          </h1>
          <div className="max-w-4xl">
            <p className="text-lg font-normal font-satoshi text-gray-100 leading-relaxed">
              <span dangerouslySetInnerHTML={parseHtmlString(leadershipData?.LEADERSHIP_THE_AFRICA_SPACE_COUNCIL?.description ?? "")} />
            </p>
          </div>
        </div>
      </div>

      {/* Leadership Council */}
      <LeadershipCouncil />

      {/* Functions & Responsibilities */}
      <FunctionsResponsibilities data={leadershipData} />

      {/* AU Assembly Section */}
      <AUAssemblySection data={leadershipData} />
    </div>
  )
}

export default Leadership